// Angular
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

// Libraries
import { Observable } from 'rxjs';
import { IConfigSharedHotel } from '../models/config-shared-hotel';
import { ConfigSharedHotelService } from 'libraries/service/resources/configuration/config-shared-hotel.service';

@Injectable()
export class ConfigSharedHotelResolver implements Resolve<IConfigSharedHotel> {
    constructor(
        private configSharedHotelService: ConfigSharedHotelService
    ) {
    }

    public resolve(): Observable<IConfigSharedHotel> {
        return this.configSharedHotelService.getConfiguration();
    }
}
